export const selectRelationshipsState = (state) => state.adminPanel.relationships;

export const selectRelationshipsData = (state) =>
  selectRelationshipsState(state).relationshipsData;

export const selectAllRelationshipsData = (state) =>
  selectRelationshipsState(state).allRelationshipsData;

export const selectRelationshipsLoading = (state) =>
  selectRelationshipsState(state).loading;

export const selectRelationshipsError = (state) =>
  selectRelationshipsState(state).error;
